/**
 * @module app.geolocationComponent
 */
import appBase from './index.js';

/**
 * @constructor
 * @param {jQuery} $element Element.
 * @param {app.GeolocationService} appGeolocationService
 * @ngInject
 * @struct
 * @private
 */
class GeolocationController {
  constructor($element, appGeolocationService) {
    /**
     * @type {jQuery}
     * @private
     */
    this.element_ = $element;

    /**
     * @type {app.GeolocationService}
     * @private
     */
    this.geolocationService_ = appGeolocationService;

    this.geolocationService_.geolocation.on('error', (event) => {
      this.element_.addClass('error');
    });

    this.geolocationService_.geolocation.on('change:position', (event) => {
      this.element_.removeClass('error');
    });
  }

  trackOnce() {
    if (this.geolocationService_) {
      this.geolocationService_.trackOnce();
    }
  }


}
/**
 * @ngdoc component
 * @ngname appGeolocation
 */
const appGeolocation = {
  controller: GeolocationController,
  template: '<button ng-click="$ctrl.trackOnce()"></button>'
};

appBase.component('appGeolocation', appGeolocation);


export default appGeolocation;
